module.exports = __webpack_public_path__ + "img/transfer-minimization.e062644d.png";